(() => {
  const ids = { single: 52970420404504, duo: 52990569283864, trio: 52990569316632 };
  const units = { [ids.single]: 1, [ids.duo]: 2, [ids.trio]: 3 };
  const root = window.Shopify?.routes?.root || '/';
  const quantity = cart => cart.items.reduce((n, item) => n + (units[item.variant_id] || 0) * item.quantity, 0);
  const split = count => ({ [ids.single]: count % 3 === 1 ? 1 : 0, [ids.duo]: count % 3 === 2 ? 1 : 0, [ids.trio]: Math.floor(count / 3) });
  async function request(path, body) {
    const response = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' }) });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Unable to update your cart. Please try again.');
    return result;
  }
  function plan(cart, count) {
    const target = split(count);
    const updates = {};
    const seen = new Set();
    for (const item of cart.items) {
      if (!units[item.variant_id]) continue;
      if (item.selling_plan_allocation || Object.keys(item.properties || {}).length) throw new Error('Please remove the personalized calendar line before changing this bundle.');
      updates[item.key] = seen.has(item.variant_id) ? 0 : target[item.variant_id];
      seen.add(item.variant_id);
    }
    for (const id of Object.values(ids)) if (!seen.has(id) && target[id]) updates[id] = target[id];
    return updates;
  }
  async function setCount(count, cart) {
    if (!Number.isSafeInteger(count) || count < 0) throw new Error('Enter a whole number of calendars.');
    const before = cart || await request('cart.js');
    const result = await request('cart/update.js', { updates: plan(before, count) });
    if (quantity(result) !== count) throw new Error('The available quantity changed. Please refresh your cart before checkout.');
    const expected = split(count);
    for (const id of Object.values(ids)) {
      if (result.items.filter(i => i.variant_id === id).reduce((sum,i) => sum+i.quantity,0) !== expected[id]) throw new Error('Your bundle could not be updated. Please refresh your cart.');
    }
    return result;
  }
  function setupProduct(el) {
    const form = el.querySelector('form[id^="da-form-"]');
    if (!form || form.dataset.quantityBound) return;
    form.dataset.quantityBound = 'true';
    const status = document.createElement('p'); status.setAttribute('role','status'); status.className='da-fine'; form.append(status);
    form.addEventListener('submit', async event => {
      const selected = form.querySelector('[data-da-bundle]:checked');
      if (!selected || !units[selected.value]) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (form.dataset.busy) return;
      form.dataset.busy='true';
      const button=form.querySelector('[data-da-add]'); button.disabled=true; status.textContent='Updating your calendars…';
      try {
        const cart=await request('cart.js');
        await setCount(quantity(cart)+units[selected.value],cart);
        location.assign(root+'cart');
      } catch(error) { status.textContent=error.message; button.disabled=false; delete form.dataset.busy; }
    },true);
  }
  function setupCart(el) {
    if(el.dataset.ready) return; el.dataset.ready='true';
    const input=el.querySelector('[data-calendar-quantity]');
    const status=el.querySelector('[data-cart-status]');
    const checkout=el.querySelector('[name="checkout"]');
    const buttons=[...el.querySelectorAll('[data-count-step], [data-count-apply], [data-calendar-remove]')];
    let busy=false;
    async function update(count) {
      if(busy) return; busy=true;
      buttons.forEach(b=>b.disabled=true); if(input)input.disabled=true; if(checkout)checkout.disabled=true;
      status.textContent='Updating your calendars…';
      try { await setCount(count); location.reload(); }
      catch(error) { status.textContent=error.message; buttons.forEach(b=>b.disabled=false); if(input)input.disabled=false; busy=false; }
    }
    el.querySelectorAll('[data-count-step]').forEach(button=>button.addEventListener('click',()=>update(Math.max(0,Number(input.value)+Number(button.dataset.countStep)))));
    el.querySelector('[data-count-apply]')?.addEventListener('click',()=>update(Number(input.value)));
    el.querySelector('[data-calendar-remove]')?.addEventListener('click',()=>update(0));
    input?.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();update(Number(input.value));}});
    input?.addEventListener('input',()=>{if(checkout)checkout.disabled=true;status.textContent='Select Update to apply your new quantity.';});
    const count=Number(el.dataset.count);
    const actual=JSON.parse(el.querySelector('[data-bundle-quantities]').textContent);
    const expected=split(count);
    if(Object.values(ids).some(id=>(actual[id]||0)!==expected[id])) update(count);
  }
  function init(scope=document) { scope.querySelectorAll('.da:not(.da-cart)').forEach(setupProduct); scope.querySelectorAll('.da-cart').forEach(setupCart); }
  init(); document.addEventListener('shopify:section:load',event=>init(event.target));
})();
